import React, {useMemo} from "react";
import PropTypes from "prop-types";
import {i18nFormat} from "../../lib/i18nFormat";

export function SelfHostedServerStatus(props) {

  const serverStatus = useMemo(() => {
    if (props.status) {
      return props.status;
    }
    if (props.server.selfHostedServerSubscriptionActive === false) {
      return "inactive";
    }
    if (props.server.selfHostedServerSubscriptionType === "monthly") {
      return "active";
    }
    if (props.server.selfHostedServerSubscriptionType === "lifetime") {
      return "lifetime";
    }
    if (props.server.selfHostedServerSubscriptionType === "trial") {
      return "trial";
    }
  }, [props.server, props.status]);


  return (
    <span className={props.className
      ? `${props.className} ${props.className}--${serverStatus}`
      : `account-shs-status account-shs-status--${serverStatus}`}>
      {i18nFormat(`shs.status.${serverStatus}`)}
    </span>
  )
}

SelfHostedServerStatus.propTypes = {
  className: PropTypes.string,
  status: PropTypes.oneOf(["inactive", "monthly", "lifetime", "trial"]),
  size: PropTypes.oneOf(["small", "default"]),
  server: PropTypes.shape({
    selfHostedServerSubscriptionActive: PropTypes.bool.isRequired,
    selfHostedServerSubscriptionType: PropTypes.oneOf(["trial", "lifetime", "monthly"]).isRequired,
  }),
}